import React, { Component } from 'react'
import Responsive from '../../Responsive'
// import Slider from '../../slider/Slider'
import SliderSingle from '../../slider/SliderSingle'




export default class Privacy extends Component {
    state = {
        info: [
            { title: "Offered by", des: "zoom.us" },
            { title: "Version", des: "1.8.13" },
            { title: "Updated", des: "March 6, 2023" },
            { title: "Size", des: "235KiB" },
            { title: "Languages", des: "English, French, Spanish" },
            { title: "Developer", des: "This developer has identified itself as a trader per the definition from the European Union." },

        ]
    }

    render() {
        return (
            <div className='w-100'>
                <div className='d-flex' style={{ backgroundColor: "#fff" }}>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", }}>
                        <div className='p-4'>
                            <div>
                                <p className='font-size-20' style={{color:"#444"}}>This developer declares that your data is:</p>
                                <ul className='px-4 mt-4'>
                                    <li className='font-size-14 py-1' style={{color:"#777"}}>Not being sold to third parties, outside of the approved use cases</li>
                                    <li className='font-size-14 py-1' style={{color:"#777"}}>Not being used or transferred for purposes that are unrelated to the item's core functionality</li>
                                    <li className='font-size-14 py-1' style={{color:"#777"}}>Not being used or transferred to determine creditworthiness or for lending purposes</li>
                                </ul>
                            </div>
                        </div>
                    </Responsive>
                </div>
            </div>
        )
    }
}
